import darkModeButton from "./dark-mode-switcher.html?raw"
import "./dark-mode-switcher.scss"
import "./dark-theme.css"

export class DarkModeSwitcher extends HTMLElement {

    async connectedCallback() {
        this.innerHTML = darkModeButton
        this.addEventListener("click", () => this.switchColorMode())

        // Wait for Webflow styles to load
        await this.waitForWebflowStyles()

        // Initialize theme
        const savedTheme = localStorage.getItem('theme')
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        const shouldBeDark = savedTheme ? savedTheme === 'dark' : prefersDark

        this.toggleTheme(shouldBeDark)

        // Listen for system theme changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            if (!localStorage.getItem('theme')) {
                this.toggleTheme(e.matches)
            }
        })
    }

    private async waitForWebflowStyles(): Promise<void> {
        const webflowStylesheet = Array.from(document.styleSheets).find(sheet =>
            sheet.href?.includes('cdn.prod.website-files.com')
        )

        if (webflowStylesheet) return

        return new Promise<void>((resolve) => {
            const observer = new MutationObserver((_, obs) => {
                const webflowStylesheet = Array.from(document.styleSheets).find(sheet =>
                    sheet.href?.includes('cdn.prod.website-files.com')
                )
                if (webflowStylesheet) {
                    obs.disconnect()
                    resolve()
                }
            })

            observer.observe(document.head, {
                childList: true,
                subtree: true
            })
        })
    }

    private toggleTheme(isDark: boolean) {
        document.body.classList.toggle('dark-theme', isDark)
        localStorage.setItem('theme', isDark ? 'dark' : 'light')

        document.dispatchEvent(new CustomEvent('theme-changed', { detail: { isDark } }))
    }



    switchColorMode() {
        const isDark = !document.body.classList.contains('dark-theme')
        console.log('Switching theme to:', isDark ? 'dark' : 'light')
        this.toggleTheme(isDark)
    }
}

customElements.define("tbw-dark-mode-switcher", DarkModeSwitcher)